// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderPreparation_wrapper__2hOcK","contentWrapper":"OrderPreparation_contentWrapper__AJtht","topGroup":"OrderPreparation_topGroup__1KRHn"};